import { isBoolean, isNull, isNumber, isString, NonNullSimpleFieldValue } from '@stylehaven/components';

export type SimpleType = string | boolean | number | null;

export function isSimpleType(x: any): x is SimpleType {
    return isString(x) || isNumber(x) || isBoolean(x) || isNull(x);
}

export function isNonNullSimpleType(x: any): x is NonNullSimpleFieldValue {
    return !isNull(x) && isSimpleType(x);
}
